module.exports = __webpack_public_path__ + "img/vmc_aniv27_24Aug2021.b637aeeb.jpg";